import { resolveStudioPublicApiBase } from '@/utils/studioApiBase'

const SCHEMA = 'https://schema.getpostman.com/json/collection/v2.1.0/collection.json'
const PRODUCTION_HOST = 'https://sociallabs.codelabs.id'

function url(raw) {
  return { raw }
}

function buildRequest(method, rawUrl, extra = {}) {
  return {
    method,
    header: [],
    url: url(rawUrl),
    ...extra,
  }
}

/** Postman collection: List designs, metadata, render only (production base URL). */
export function buildStudioPostmanCollection({
  apiKey = '',
  designId = '',
  page = 1,
  format = 'png',
} = {}) {
  const apiBase = resolveStudioPublicApiBase()
  const id = designId || '{{designId}}'
  const key = apiKey || '{{apiKey}}'
  const pageStr = String(page || 1)
  const fmt = format || 'png'

  return {
    info: {
      name: 'SocialLabs Studio API',
      description:
        `Public Studio API (3 endpoints).\n\n` +
        `Production: ${PRODUCTION_HOST}/api/v1/public/studio\n` +
        `Auth: header X-API-Key (or Authorization: ApiKey <key>).\n\n` +
        `Collection base URL: ${apiBase}`,
      schema: SCHEMA,
    },
    variable: [
      { key: 'baseUrl', value: apiBase },
      { key: 'apiKey', value: key },
      { key: 'designId', value: id },
      { key: 'page', value: pageStr },
      { key: 'format', value: fmt },
    ],
    auth: {
      type: 'apikey',
      apikey: [
        { key: 'key', value: 'X-API-Key', type: 'string' },
        { key: 'value', value: '{{apiKey}}', type: 'string' },
        { key: 'in', value: 'header', type: 'string' },
      ],
    },
    item: [
      {
        name: 'Get designs',
        request: buildRequest('GET', '{{baseUrl}}/public/studio'),
        description: `List your saved designs (id, name, size, page count).\nExample: GET ${PRODUCTION_HOST}/api/v1/public/studio`,
      },
      {
        name: 'Get design metadata',
        request: buildRequest('GET', '{{baseUrl}}/public/studio/{{designId}}?page={{page}}'),
        description:
          `Editable fields and canvas size for a design.\n` +
          `Example: GET ${PRODUCTION_HOST}/api/v1/public/studio/{designId}?page=1`,
      },
      {
        name: 'Render design',
        request: buildRequest(
          'GET',
          '{{baseUrl}}/public/studio/{{designId}}/download?page={{page}}&format={{format}}',
        ),
        description:
          `Returns PNG or JPEG binary (format=png|jpg).\n` +
          `Example: GET ${PRODUCTION_HOST}/api/v1/public/studio/{designId}/download?page=1&format=png\n` +
          `Use POST with JSON body { page, format, fields } for text/image overrides (see API docs).`,
      },
    ],
  }
}

export function downloadStudioPostmanCollection(collection) {
  const json = JSON.stringify(collection, null, 2)
  const blob = new Blob([json], { type: 'application/json' })
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = 'sociallabs-studio-api.postman_collection.json'
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
}
